export default `
query {
  company_types {
    types
  }
}
`;
